<template>
  <div>
    <el-dialog
      :visible="visible"
      :title="dialogTitle"
      width="666px"
      :close-on-click-modal="true"
      class="entrusted-detail-dialog"
      @close="handleClose"
    >
      <div class="dialog-content">
        <!-- 左侧信息区域 -->
        <div class="info-section">
          <!-- 地址信息 -->
          <div class="info-item">
            <div class="info-label">地址</div>
            <div class="info-value">{{ detailInfo.address }}</div>
          </div>

          <!-- 托管人/农户代表人 -->
          <div class="info-item">
            <div class="info-label">托管人/农户代表人</div>
            <div class="info-value">{{ detailInfo.custodian }}</div>
          </div>

          <!-- 面积信息 -->
          <div class="info-item">
            <div class="info-label">面积（亩）</div>
            <div class="info-value">{{ detailInfo.area }}</div>
          </div>

          <!-- 作物种类 -->
          <div class="info-item">
            <div class="info-label">作物种类</div>
            <div class="info-value">{{ detailInfo.cropType }}</div>
          </div>

          <!-- 环节信息 -->
          <div class="info-item">
            <div class="info-label">环节</div>
            <div class="info-value">{{ detailInfo.stage }}</div>
          </div>

          <!-- 期限信息 -->
          <div class="info-item">
            <div class="info-label">期限</div>
            <div class="info-value">{{ detailInfo.term }}</div>
          </div>

          <!-- 总金额 -->
          <div class="info-item amount-item">
            <div class="info-label">总金额（元）</div>
            <div class="info-value amount">{{ detailInfo.amount }}</div>
          </div>
        </div>

        <!-- 右侧合同图片区域 -->
        <div class="contract-section">
          <div class="section-title">托管合同</div>
          <!-- 有合同图片时显示图片 -->
          <el-image
            v-if="detailInfo.contractImage"
            class="contract-image-container"
            :src="detailInfo.contractImage"
            :preview-src-list="detailInfo.contractImageList"
            fit="contain"
          ></el-image>
          <!-- 无合同图片时显示空状态 -->
          <div v-else class="no-contract-container">
            <img src="/imgs/默认文件.png" alt="暂无合同" class="no-contract-icon" />
            <div class="no-contract-text">暂无托管合同</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { selectLandDetail } from '@/api/add'
import { selectOrderContract } from '@/api/projectManage'

export default {
  name: 'EntrustedDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    contractNo: {
      type: String,
      default: ''
    },
    orderId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      photoBaseUrl: window.globalUrl.BASE_API + 'admin/file/get?ossFilePath=',
      dialogTitle: '',
      detailInfo: {
        // address: '哈尔滨市南岗区王贤镇王前村',
        // custodian: '王强',
        // area: '3236.45亩',
        // cropType: '水稻',
        // stage: '全程托管',
        // term: '2025年4月-2025年10月',
        // amount: '¥1,488,767',
        // contractImage: '/admin/file/cqjy/register/202506/aa5135acad2148d295547ea58fafd234.jpeg',
        // contractImageList: ['/admin/file/cqjy/register/202506/aa5135acad2148d295547ea58fafd234.jpeg']
      }
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        if (newVal) {
          this.init()
        }
      }
    }
  },
  methods: {
    async init() {
      this.dialogTitle = `托管单详情：${this.contractNo}`
      await this.loadData()
    },

    async loadData() {
      const res = await selectLandDetail({ orderId: this.orderId })
      if (res.code === 0) {
        this.detailInfo = {
          address: res.data.areaName || '',
          custodian: res.data.takeOverName || '',
          area: res.data.landArea ? res.data.landArea.toFixed(2) : '0',
          cropType: res.data.cropCode || '',
          stage: res.data.orderContent || '',
          term: `${res.data.startDate || ''} - ${res.data.endDate || ''}`,
          amount: res.data.estimatePrice || '',
          //这里必须先声明，否则不会显示图片,因为是异步操作！！！
          contractImage: '',
          contractImageList: []
        }
      }

      let res1 = await selectOrderContract({ orderId: this.orderId })
      if (res1.code === 0) {
        try {
          const picData = JSON.parse(res1.data.picUrl || '[]')

          if (Array.isArray(picData) && picData.length > 0) {
            // 直接处理图片URL
            this.detailInfo.contractImageList = picData
              .filter(item => item && item.imgUrl)
              .map(item => this.photoBaseUrl + item.imgUrl)

            this.detailInfo.contractImage = this.detailInfo.contractImageList[0] || ''
          }
        } catch (error) {
          console.error('解析图片数据失败:', error)
        }
      }
    },

    // 关闭对话框
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less" scoped>
// 变量定义 - 从设计稿提取
@primary-color: #2563eb; // 主色调
@success-color: #16a34a; // 成功色（金额）
@text-primary: #1f2937; // 主文本色
@text-secondary: #6b7280; // 次要文本色
@white: #ffffff; // 白色背景
@border-radius: 8px; // 圆角
@box-shadow: 0px 11.38px 35.41px 8px rgba(0, 0, 0, 0.05), 0px 3.79px 7.59px -4px rgba(0, 0, 0, 0.12),
  0px 7.59px 20.23px 0px rgba(0, 0, 0, 0.08); // 阴影

.entrusted-detail-dialog {
  .el-dialog__header {
    padding: 25px 30px 20px;

    .el-dialog__title {
      font-size: 20px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.88);
      line-height: 30px;
    }

    .el-dialog__headerbtn {
      top: 22px;
      right: 25px;

      .el-dialog__close {
        font-size: 20px;
        color: rgba(0, 0, 0, 0.45);

        &:hover {
          color: @primary-color;
          background-color: rgba(37, 99, 235, 0.1);
        }
      }
    }
  }

  .el-dialog__body {
    padding: 20px 30px 30px;
  }

  .el-dialog__footer {
    padding: 15px 30px;
    border-top: 1px solid #ebeef5;
    text-align: right;
  }
}

.dialog-content {
  display: flex;
  gap: 30px;

  // 左侧信息区域
  .info-section {
    flex: 1;
    min-width: 0;

    .info-item {
      margin-bottom: 14px;

      .info-label {
        font-size: 17.7px;
        color: @text-secondary;
        line-height: 25.3px;
        margin-bottom: 5px;
      }

      .info-value {
        font-size: 17.7px;
        font-weight: 500;
        color: @text-primary;
        line-height: 27.8px;
      }

      &.amount-item {
        margin-top: 10px;

        .info-value.amount {
          font-size: 30.3px;
          font-weight: 700;
          color: @success-color;
          line-height: 40.5px;
        }
      }
    }
  }

  // 右侧合同图片区域
  .contract-section {
    flex: 1;
    min-width: 0;

    .section-title {
      font-size: 17.7px;
      color: @text-secondary;
      line-height: 25.3px;
      margin-bottom: 20px;
    }

    .contract-image-container {
      width: 100%;
      height: 400px;
      border: 1px solid #ebeef5;
      border-radius: 4px;
      overflow: hidden;
    }

    // 无合同状态样式
    .no-contract-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 400px;
      border: 1px dashed #d9d9d9;
      border-radius: 4px;
      background-color: #fafafa;

      .no-contract-icon {
        width: 64px;
        height: 64px;
        margin-bottom: 12px;
        opacity: 0.6;
      }

      .no-contract-text {
        font-size: 14px;
        color: @text-secondary;
        text-align: center;
      }
    }
  }
}

// 预览图片样式
.preview-image {
  width: 100%;
  height: auto;
  max-height: 60vh;
  object-fit: contain;
}

// 响应式设计
@media (max-width: 1024px) {
  .dialog-content {
    flex-direction: column;
    gap: 20px;

    .info-section {
      .info-item {
        margin-bottom: 20px;

        &.amount-item {
          .info-value.amount {
            font-size: 24px;
          }
        }
      }
    }

    .contract-section {
      .contract-image-container {
        max-height: 300px;
      }

      .no-contract-container {
        height: 180px;

        .no-contract-icon {
          width: 56px;
          height: 56px;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .entrusted-detail-dialog {
    .el-dialog__header {
      padding: 20px 20px 15px;

      .el-dialog__title {
        font-size: 18px;
      }
    }

    .el-dialog__body {
      padding: 15px 20px 25px;
    }
  }

  .dialog-content {
    .info-section {
      .info-item {
        .info-label,
        .info-value {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
